export default "__VITE_ASSET__a7c8f155__"